// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: 'Seleziona',
    titleLinkTooltip: 'Vai alla pagina',
    collapseCardTooltip: 'Comprimi la scheda',
    expandCardTooltip: 'Espandi la scheda'
  },
  CardList: {
    loadMore: 'Carica altro',
    notFound: 'Nessun elemento trovato.',
    toolbarSelect: 'Seleziona',
    viewCards: 'Schede',
    viewTiles: 'Riquadri',
    viewList: 'Lista',
    toolbarView: 'Vista'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: 'Abbandona',
    cancel: 'Indietro',
    content: 'Confermi di voler chiudere e abbandonare questa finestra? Eventuali modifiche apportate non verranno salvate.'
  },
  Cuttable: {
    showMore: 'Mostra di più',
    showLess: 'Mostra meno'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: 'Annulla'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: 'Annulla'
  },
  Dropdown: {
    close: 'Chiudi'
  },
  Form: {
    submitButton: 'Salva',
    applyButton: 'Applica',
    cancelButton: 'Annulla'
  },
  FormField: {
    clear: 'Cancella',
    remove: 'Rimuovi',
    addMore: 'Aggiungine un altro',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: 'Per migliorare la password:',
    passwordTooShort: 'Aggiungi caratteri.',
    lettersLowerCase: 'Usa almeno un carattere minuscolo.',
    lettersUpperCase: 'Usa almeno un carattere maiuscolo.',
    numbers1: 'Usa almeno un numero.',
    numbers3: 'Usa almeno tre numeri.',
    specialChar1: 'Usa almeno un carattere speciale (per esempio: !,@,#,$,%,^,&,*,?,_,~).',
    specialChar2: 'Usa almeno due caratteri speciali (per esempio: !,@,#,$,%,^,&,*,?,_,~).',
    comboUpperAndLower: 'Usa caratteri maiuscoli e minuscoli.',
    comboLettersAndNumbers: 'Usa sia numeri che caratteri.',
    comboLettersNumbersSpecial: 'Usa numeri, caratteri e caratteri speciali.',
    yourPasswordIsStrong: 'Puoi renderla ancora più efficace aggiungendo caratteri.',
    passwordStrength: 'La password è %%strength%%.',
    strengthVeryStrong: 'MOLTO EFFICACE',
    strengthStrong: 'EFFICACE',
    strengthVeryWeak: 'MOLTO DEBOLE',
    strengthWeak: 'DEBOLE',
    strengthMedium: 'MEDIA',
    hidePassword: 'Nascondi password',
    showPassword: 'Mostra password',
    generateButton: 'Genera',
    copyButtonHint: 'Copia password',
    copySuccessToast: 'Password copiata',
    generateButtonHint: 'Genera una password efficace'
  },
  InPlaceEdit: {
    cancelButtonHint: 'Annulla modifiche',
    editButtonHint: 'Modifica valore',
    okButtonHint: 'Salva modifiche'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: 'Scegli file...'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: '%%totalRows%% elementi in totale',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: 'Elementi selezionati: %%selectedRows%% di %%totalRows%%',
    all: 'Tutti',
    allItemsOnPageSelected: 'Tutti gli elementi della pagina sono stati selezionati',
    allItemsSelected: 'Tutti gli elementi sono stati selezionati',
    selectAllItems: 'Seleziona tutti gli elementi',
    selectAllItemsOnPage: 'Seleziona tutti gli elementi sulla pagina',
    deselectAll: 'Deseleziona',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: 'Impossibile trovare elementi corrispondenti al filtro',
    emptyTitle: "Qui non c'è nulla",
    filteredDescription: 'Perfeziona la query o rimuovi alcuni criteri dal filtro e riprova.'
  },
  ListOperation: {
    cancelButton: 'Annulla'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: 'di %%total%%',
    itemsPerPage: 'Elementi per pagina',
    all: 'Tutti',
    total: 'Pagina %%current%% di %%total%%'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: 'Chiudi',
    cancelButton: 'Annulla'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: 'Nessuna opzione',
    placeholder: 'Seleziona...'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%% di %%total%%'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: 'Chiudi gruppo'
  },
  Toast: {
    closeButton: 'Close'
  }
};